export { default } from '@/features/personnel/api';
